import { InjectionToken } from '@angular/core';

export const ISS_ICONS_PATH = new InjectionToken<string>('ISS_ICONS_PATH');
